<template>
    <select v-model="displayValue" class="form-control" id="id_parceiro" >
        <option v-for="m in chips" :value="m.id_parceiro" >{{m.nome}}</option>
    </select>
</template>

<script>
    import { Parceiros } from '../../class/parceiro';

    export default {
        name: 'ComboParceiro',
        props: {
            "value": {
                "default": null
            },
            id_parceiro: {
                "default": null
            }
        },
        data(){
            return {
                chips: [],
            };
        },
        beforeMount(){
            this.loadChips();
        },
        methods: {
            async loadChips(){
                Parceiros.combo().then((rows) => {
                    this.chips = rows;
                    this.chips.push({
                        id_parceiro: null,
                        nome: "SEM PARCEIRO"
                    });
                })
                .catch((err) => console.log(err));
            }
        },
        computed: {
            displayValue: {
                get() {
                    return this.value;
                },
                set(modifiedValue) {
                    this.$emit("input", modifiedValue);
                }
            }
        }
    };
</script>

<style scoped>

</style>
